import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router";
import { useAuth } from "./AuthContext";
import { Button, Form } from "react-bootstrap";
import { host } from "./globalVariables";
import { getOOUserData } from "./networkFunctions";

export default function Login({}) {
   const [username, setUsername] = useState("");
   const [password, setPassword] = useState("");
   const [error, setError] = useState("");
   const [initialConfig, setInitialConfig] = useState();
   const [isSubmitting, setIsSubmitting] = useState(false);

   const { setUser, authError, login } = useAuth();
   const location=useLocation()
   const navigate = useNavigate();

   const from = location.state?.from || "/";

   useEffect(() => {
      console.log("getinitialconfig");

      fetch(host + "/api/getInitialConfig")
         .then((data) => {
            data.json().then((cleanData) => {
               console.log(cleanData);

               setInitialConfig(cleanData);
            });
         })
         .catch((err) => {
            console.log(err);
         });
   }, []);


const handleSubmit = async (e) => {
   e.preventDefault();
   setError("");
   setIsSubmitting(true);

   try {
      const result = await login(username, password);
      if (result.ok) {
         navigate(from, { replace: true });
      } else {
         setError(result.message);
      }
   } catch (err) {
      console.error(err);
      setError("Verbindung zum Server fehlgeschlagen.");
   } finally {
      setIsSubmitting(false);
   }
};



   /* const handleSubmit = async (e) => {
      e.preventDefault();
      setError("");
      setIsSubmitting(true);

      try {
         const response = await fetch(host + "/api/login", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ username, password }),
            credentials: "include", // WICHTIG für den HttpOnly Cookie
         });
         console.log(response);

         const data = await response.json();
         console.log(data);

         if (response.ok) {
            let myFullUser = await getOOUserData(data.user.name);
            console.log(myFullUser);
            console.log({ ...data.user, ...myFullUser });
            
            setUser({ ...data.user, ...myFullUser }); // User im Context speichern
            navigate(from, { replace: true });
         } else {
            setError(data.message || "Login fehlgeschlagen. Bitte Daten prüfen.");
         }
      } catch (err) {
         console.log(err);

         setError("Verbindung zum Server fehlgeschlagen.");
      } finally {
         setIsSubmitting(false);
      }
   }; */

   return (
      <div className="mt-5" style={{ width: "100vw", display: "flex", alignItems: "center", justifyContent: "center" }}>
         {initialConfig && (
            <div
               className="p-3"
               style={{
                  width: "90vw",
                  maxWidth: "400px",
                  backgroundColor: initialConfig.colorScheme.secondary,
                  color: initialConfig.colorScheme.primary,
                  borderRadius: "14px",
                  boxShadow: "0 0 40px #0009",
               }}
            >
               <img
                  // src={logo_baur}
                  src={host + "/images/logo.svg"}
                  // width="150"
                  //  height="32"
                  style={{ borderRadius: "12px" }}
                  className="d-inline-block align-top p-1 w-100"
                  alt="logo"
               />
               <h2 className="m-3">Login</h2>

               {authError === "Sitzung abgelaufen" && (
                  <div className="p-2" style={{ color: "#f99" }}>
                     Vergangene Sitzung abgelaufen, bitte erneut einloggen.
                  </div>
               )}
               {error && (
                  <div className="p-2" style={{ color: "#f00" }}>
                     {error}
                  </div>
               )}
               <Form onSubmit={handleSubmit} className="p-3">
                  <Form.Group className="mb-3" key="lgnusr">
                     <Form.Label>Nutzername</Form.Label>
                     <Form.Control
                        type="text"
                        required
                        className=""
                        //  style={{boxShadow: "0 0 10px #fff"}}
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                     />
                  </Form.Group>
                  <Form.Group className="mb-3" key="lgnpw">
                     <Form.Label>Passwort</Form.Label>
                     <Form.Control
                        type="password"
                        required
                        className=""
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                     />
                  </Form.Group>
                  <Button
                     style={{ backgroundColor: initialConfig.colorScheme.signature }}
                     variant="dark"
                     type="submit"
                     disabled={isSubmitting}
                     className=""
                  >
                     {isSubmitting ? "Wird geprüft..." : "Anmelden"}
                  </Button>
               </Form>
            </div>
         )}
      </div>
   );
}
